export default {
  id: 53,
  title: 'Target #53 - Pastel Logo',
  url: 'https://cssbattle.dev/play/53',
  colors: ['#19191A', '#4F77FF', '#9AD5FF', '#F9E492'],
  solution:
    '<a a><a b><a c><style>body{background:#19191A}a{position:fixed}a[a],a[b],a[c]{left:125}a[b],a[c]{top:125;width:75}a[a]{top:50;width:150;height:150;background:#4F77FF;border-radius:50%}a[b]{height:125;background:#F9E492}a[c]{height:75;border-radius:0 0 0 75px;background:#9AD5FF}</style>',
}
